module.exports = __webpack_public_path__ + "img/Logo-Radio-Trunk_blanco.68d392b0.png";